var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_5882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3828 22.067V5.8431C24.3828 4.56836 23.3398 3.52539 22.0651 3.52539H5.84114C4.56641 3.52539 3.52344 4.56836 3.52344 5.8431V22.067C3.52344 23.3418 4.56641 24.3848 5.84114 24.3848H22.0651C23.3398 24.3848 24.3828 23.3418 24.3828 22.067ZM9.89713 15.6933L12.7943 19.1815L16.8503 13.9551L22.0651 20.9082H5.84114L9.89713 15.6933Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_5882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8125,
    height: 27.8125,
    fill: "white",
    transform: "translate(0.046875 0.0478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.e96a60704bcfb2afa28506a79ab0b22f.svg";
export { ForwardRef as ReactComponent };